import {Card, Empty} from 'antd';
import {useMemo} from 'react';

import {LineChart} from '../../../../../../layout/chart/line-chart/line-chart';
import {LineDataType} from '../../../../../../layout/chart/line-chart/line-chart-type';
import {Locale} from '../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {AiMonitoringScorePointType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {TONALITY_METRIC_COLOR, VISIBILITY_METRIC_COLOR} from './brand-analysis-const';
import * as styles from './analysis-dynamics-chart.scss';

type PropsType = {
    series: Array<AiMonitoringScorePointType>;
};

export function AnalysisDynamicsChart(props: PropsType): JSX.Element {
    const {series} = props;
    const {getLocalizedString} = useLocale();

    const lineData = useMemo<LineDataType | null>(() => {
        if (series.length === 0) {
            return null;
        }

        return {
            labels: series.map((point) => point.date),
            datasets: [
                {
                    label: getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__VISIBILITY'),
                    values: series.map((point) => point.visibilityScore ?? 0),
                    color: VISIBILITY_METRIC_COLOR,
                    width: 2,
                },
                {
                    label: getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__TONALITY'),
                    values: series.map((point) => point.tonalityScore ?? 0),
                    color: TONALITY_METRIC_COLOR,
                    width: 2,
                },
            ],
        };
    }, [series, getLocalizedString]);

    return (
        <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__DYNAMICS" />}>
            {lineData ? (
                <div className={styles.analysis_dynamics_chart__canvas}>
                    <LineChart data={lineData} />
                </div>
            ) : (
                <Empty description={getLocalizedString('AI_BRAND_MONITORING__DASHBOARD__NO_DATA')} />
            )}
        </Card>
    );
}
